import { FormControlLabel, Radio } from "@mui/material";
import React, { useContext, useEffect, useState } from 'react'
import { WorkflowContext, WorkflowContextPayload } from "../../../../../../context/workflowContext";
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import { isCurrentViewVersionPublished } from "../../../utilityFunctions";



const RenderFormControlLabel = (label: string, value: boolean) => {
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;
    return (
        <FormControlLabel
            className={globalStyles.radioLabelStyle}
            value={value}
            control={<Radio className={globalStyles.radioButton} disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)} />}
            label={label}
        />
    );
}

export default RenderFormControlLabel;